angular.module('shared-components.popup.employee', [
  'shared-components.popup',
  'data.employee'
]);
